import * as React from "react";
function SvgGenders(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M41.3 0l-8.4.3L29.4 4l6.3-.2-6.6 7.1c-5.4-5.1-14-4.8-19.1.6s-4.8 14 .6 19.1c2 1.9 4.6 3.1 7.3 3.5v6.4h-4.5v3H18V48h3v-4.5h4.5v-3H21v-6.3c7.4-.6 13-7.1 12.4-14.5-.2-2.3-1-4.5-2.3-6.5l6.8-7.4.2 6.3 3.4-3.7-.2-8.4zM19.9 31.2c-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5 10.5 4.7 10.5 10.5-4.7 10.5-10.5 10.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGenders);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
